import axios from 'axios';
import App from '../main';
import { Loading } from 'element-ui';
const delayTime = 0; //设置相应时间超过100ms 才显示loading 否则不显示loading
let loadTimeout;
let LoadingInstance = null;
import store from '@/store';
import configData from './settings';
import router from '../router/index';
import codeMap from '@/utils/codeMap';

const service = axios.create({
  baseURL: '/gateway/pcapp/',
  timeout: 20000, // 请求超时时间
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
});

import keyjs from '@/assets/js/key';
import CryptoJS from 'crypto-js';
var key = CryptoJS.enc.Latin1.parse(keyjs); //密钥
var iv = CryptoJS.enc.Latin1.parse(keyjs); //密钥偏移量
// 加密
function EncryptData(data) {
  var srcs = CryptoJS.enc.Utf8.parse(data);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

// 解密
function DecryptData(data) {
  var decrypt = CryptoJS.AES.decrypt(data, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
    iv: iv
  });
  var result = JSON.parse(CryptoJS.enc.Utf8.stringify(decrypt).toString());
  return result;
}

service.interceptors.request.use(
  (config) => {
    if (!config.data) {
      config.data = {};
    }
    config.data = Object.assign(config.data);

    if (!(config.authParams && config.authParams.noLoading)) {
      loadTimeout = setTimeout(() => {
        LoadingInstance = App.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      }, delayTime);
    }

    if (
      !(config.authParams && config.authParams.defaultData) &&
      configData.decryptType === 'open'
    ) {
      // config.data = config.data
      // config.data = qs.stringify(config.data)
      config.data = EncryptData(JSON.stringify(config.data)); //加密
    }

    if (router.history.current.fullPath.indexOf('platform=') != -1) {
      sessionStorage.setItem('platform', router.history.current.query.platform || '');
    }

    if (router.history.current.fullPath.indexOf('recommendCode=') != -1) {
      sessionStorage.setItem('recommendCode', router.history.current.query.recommendCode || '');
    }

    if (config.params && config.params.UUID) {
      sessionStorage.setItem('UUID', config.params.UUID);
    }

    // console.log('sessionStorage.getItem(UUID)', sessionStorage.getItem('UUID'));

    config.headers['UUID'] = sessionStorage.getItem('UUID') || '';
    config.headers['PLAT-FORM'] = sessionStorage.getItem('platform');
    config.headers['CHANNEL'] = window.screen.width <= 767 ? 'h5' : 'eshop';

    return config;
  },
  function (error) {
    clearTimeout(loadTimeout);
    if (LoadingInstance) {
      LoadingInstance.close();
      LoadingInstance = null;
    }
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    if (response.status == 401) {
      router.replace({ path: '/' });
    }
    if (typeof response.data == 'string' && configData.decryptType === 'open') {
      response.data = DecryptData(response.data);
    } //解密
    if (!(response.config.authParams && response.config.authParams.endNone)) {
      if (response.data.code !== '200') {
        // 拦截白名单不处理 其他的直接弹框
        let codeList = ['120075', '120067', '90010', '90052', '120099', '120089', '120101'];
        if (!codeList.includes(response.data.code)) {
          if (!response.data.message) return;
          App.$alert(response.data.message, '提示', {
            confirmButtonText: '确定',
            customClass: 'alert-box',
            callback: () => {
              if (response.data.code === '-101') {
                App.$router.push('/');
              }
            }
          });
        }
      }
    }

    if (!(response.config.authParams && response.config.authParams.noLoading)) {
      clearTimeout(loadTimeout);
      if (LoadingInstance) {
        LoadingInstance.close();
        LoadingInstance = null;
      }
    }

    return response.data;
  },
  function (error) {
    console.log('errCode', error);
    if (
      !(
        error &&
        error.response &&
        error.response.config.authParams &&
        error.response.config.authParams.endNone
      )
    ) {
      const response = error.response;
      const errCode = (response && response.error_description) || '';
      const httpCode = (response && response.status) || '';
      if (errCode) {
        let errorMsg = codeMap[errCode];
        if (!errorMsg) errorMsg = errCode + '网络异常，请稍后再试';
        App.$alert(errorMsg, '提示', {
          confirmButtonText: '确定',
          customClass: 'alert-box'
        });
      } else {
        let httpMsg = codeMap[httpCode];
        if (!httpMsg) httpMsg = httpCode + '网络异常，请稍后再试';
        App.$alert(httpMsg, '提示', {
          confirmButtonText: '确定',
          customClass: 'alert-box'
        });
      }
    }
    clearTimeout(loadTimeout);
    if (LoadingInstance) {
      LoadingInstance.close();
      LoadingInstance = null;
    }
    return Promise.reject(error);
  }
);

export default service;
